module.exports = __webpack_public_path__ + "static/media/BinIconDelete.1e8dcde3.svg";